import React from "react";
import Octicon from "react-octicon";

function VerticalBars({ num }) {
  let vertical_bars = [];
  let style = {
    height: "100%",
    minHeight: "1.5rem", // Fallback minimum height
    borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
    marginLeft: "0.25rem",
    marginRight: "1rem",
    display: "inline-block",
    verticalAlign: "top",
  };
  for (let i = 0; i < num; i++) {
    vertical_bars.push(<div key={i} className="tree-indent-line" style={style}></div>);
  }
  return vertical_bars;
}

export function Indent({ depth, onClickHandler, expanded = true, disabled = false }) {
  if (!depth) return null;

  return (
    <div
      className="indent-container"
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexShrink: 0,
        //height: "100%",
        //minHeight: "1.5rem",
      }}
    >
      <VerticalBars num={depth} />
      <span
        className="m-0 p-0 mt-1"
        style={{
          cursor: disabled ? "default" : "pointer",
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "flex-start",
        }}
        onClick={disabled ? undefined : onClickHandler}
      >
        <Octicon name={disabled ? "dash" : expanded ? "triangle-down" : "triangle-right"} />
      </span>
    </div>
  );
}
